import { IconProps } from "../types";

export const SidebarCloseIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.3228 10L18.455 2.8629C18.8177 2.5 18.8177 1.89516 18.455 1.53226C18.0924 1.16935 17.488 1.16935 17.1253 1.53226L9.993 8.66935L2.86071 1.53226C2.48462 1.15591 1.89362 1.15591 1.53096 1.53226C1.1683 1.9086 1.15487 2.48656 1.53096 2.8629L8.66325 10L1.53096 17.1371C1.1683 17.5 1.1683 18.1048 1.53096 18.4677C1.71901 18.6559 1.96078 18.75 2.20255 18.75C2.44432 18.75 2.6861 18.6559 2.87414 18.4677L10.0064 11.3306L17.1387 18.4677C17.3268 18.6559 17.5685 18.75 17.8103 18.75C18.0521 18.75 18.2939 18.6559 18.4819 18.4677C18.8446 18.1048 18.8446 17.5 18.4819 17.1371L11.3496 10H11.3228Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
